<app-dialog-wrapper
    heading="common.assign-dialog.emea.title"
    description="common.assign-dialog.emea.description"
    confirmLabel="common.assign-dialog.emea.confirm"
    cancelLabel="common.general.cancel"
    (confirmed)="confirm()"
    (cancelled)="close()"
>
    <sh-user-picker
        label="{{ 'common.assign-dialog.emea.assignee' | translate }}"
        [formControl]="selectedUser"
        [roles]="[rolesEnum.TASK_OWNER]"
    ></sh-user-picker>
</app-dialog-wrapper>
